export default __webpack_public_path__ + "static/media/4.f669b285.png";